import React, { useContext, useEffect, useState } from 'react';
import { bool, shape } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import { enqueueSnackbar } from '../../actions/applicationMessageActions';
import { getErrorMessage } from '../../helpers/errors';
import MetaContext from './MetaContext';
import { fetchRuleKPIs, getRule, saveRule } from '../../actions/ruleActions';
import Switch from '../FormFields/Switch';

const EnabledStateCell = ({ row, ...props }) => {
    const { readOnly } = useContext(MetaContext);
    const dispatch = useDispatch();
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(false);

    useEffect(() => {
        if (!saveError) {
            return;
        }
        dispatch(enqueueSnackbar(saveError, 'error'));
    }, [saveError]);

    async function handleChange(event) {
        const { name, value } = event.target;
        setIsSaving(true);
        setSaveError(null);
        const rulePayload = await dispatch(getRule(row.id));
        let updatedRule = rulePayload.data;
        updatedRule[name] = value;
        try {
            await dispatch(saveRule(updatedRule));
            await dispatch(fetchRuleKPIs());
        } catch (error) {
            setSaveError(getErrorMessage(error));
        } finally {
            setIsSaving(false);
        }
    }

    if (isSaving) {
        return (
            <Table.Cell {...props}>
                <CircularProgress
                    size={20}
                />
            </Table.Cell>
        );
    }
    return (
        <Table.Cell {...props}>
            <Switch
                checked={row.enabled}
                disabled={readOnly}
                disableRipple
                name="enabled"
                onChange={handleChange}
            />
        </Table.Cell>
    );
};

EnabledStateCell.defaultProps = {
    row: {
        enabled: false
    }
};

EnabledStateCell.propTypes = {
    row: shape({
        enabled: bool
    })
};

export default EnabledStateCell;
